import { Fragment, useState, useEffect } from "react";
import AddressesPreview from "../../../../utils/forms/address/AddressesPreview";
import AddressPopup from "../../popup/popups/AddressPopUp";

const initialAddress = {
  address: "",
  suiteAddress: "",
  city: "",
  stateAddress: "Alabama",
  zipCode: "",
  country: "US",
};

function SingleAddress({ formState, setFormState, fieldNames, formMethods, fieldName = "businessAddress", showDelete = true, showEdit = true }) {
  // Get the current address from formState
  const currentAddressValue = formState[fieldName];
  
  // Convert single address to array format for AddressesPreview
  const addressesArray = currentAddressValue && 
    (currentAddressValue.address || currentAddressValue.city || currentAddressValue.stateAddress)
    ? [currentAddressValue]
    : [];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentAddress, setCurrentAddress] = useState(
    currentAddressValue && Object.keys(currentAddressValue).length > 0
      ? currentAddressValue
      : initialAddress
  );

  // Update currentAddress when formState changes
  useEffect(() => {
    if (currentAddressValue && Object.keys(currentAddressValue).length > 0) {
      setCurrentAddress(currentAddressValue);
    } else {
      setCurrentAddress(initialAddress);
    }
  }, [currentAddressValue]);

  const handleAddClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setCurrentAddress(initialAddress);
    setIsModalOpen(true);
  };

  const handleEditClick = () => {
    setCurrentAddress(currentAddressValue || initialAddress);
    setIsModalOpen(true);
  };

  const handleSave = (address) => {
    // Remove fromDate and toDate for single addresses
    const { fromDate, toDate, ...addressWithoutDates } = address;
    const cleanedAddress = addressWithoutDates;
    
    // Update both the consolidated field and individual fields at root level
    const updatedState = {
      ...formState,
      [fieldName]: cleanedAddress,
      // Also set individual fields at root level for validation
      [fieldNames.address]: cleanedAddress.address || "",
      [fieldNames.suiteAddress]: cleanedAddress.suiteAddress || "",
      [fieldNames.city]: cleanedAddress.city || "",
      [fieldNames.stateAddress]: cleanedAddress.stateAddress || "",
      [fieldNames.zipCode]: cleanedAddress.zipCode || "",
    };
    
    if (formMethods) {
      // Set the consolidated field
      formMethods.setValue(fieldName, cleanedAddress, {
        shouldValidate: true,
        shouldDirty: true,
      });
      
      // Also set individual fields for validation
      formMethods.setValue(fieldNames.address, cleanedAddress.address || "", {
        shouldValidate: true,
        shouldDirty: true,
      });
      formMethods.setValue(fieldNames.city, cleanedAddress.city || "", {
        shouldValidate: true,
        shouldDirty: true,
      });
      formMethods.setValue(fieldNames.stateAddress, cleanedAddress.stateAddress || "", {
        shouldValidate: true,
        shouldDirty: true,
      });
      formMethods.setValue(fieldNames.zipCode, cleanedAddress.zipCode || "", {
        shouldValidate: true,
        shouldDirty: true,
      });
      
      // Trigger validation on all address-related fields
      setTimeout(() => {
        formMethods.trigger([fieldName, fieldNames.address, fieldNames.city, fieldNames.stateAddress, fieldNames.zipCode]);
      }, 100);
    }
    
    setFormState(updatedState);
    setIsModalOpen(false);
  };

  // Check if address exists (has at least one meaningful field)
  const hasAddress = currentAddressValue && 
    (currentAddressValue.address || currentAddressValue.city || currentAddressValue.stateAddress);

  return (
    <Fragment>
      {hasAddress && (
        <AddressesPreview
          addresses={addressesArray}
          onEdit={handleEditClick}
          showEdit={showEdit}
          showDelete={showDelete}
          showDates={false}
        />
      )}
      
      {!hasAddress && (
        <div>
          <button
            type="button"
            className="add-button"
            onClick={handleAddClick}
          >
            <span className="material-icons">+</span>
            <span>Add Address</span>
          </button>
        </div>
      )}

      {isModalOpen && (
        <AddressPopup
          editingIndex={hasAddress ? 0 : null}
          setCurrentAddress={setCurrentAddress}
          currentAddress={currentAddress}
          setIsModalOpen={setIsModalOpen}
          handleSave={handleSave}
          isMulti={false}
        />
      )}
    </Fragment>
  );
}

export default SingleAddress;
